import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["value", "tokens"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as t } from "react/jsx-runtime";
import e, { useContext as s } from "react";
import { PortableText as d } from "@portabletext/react";
import { BlockContentPlaceholderResolverContext as p } from "./BlockContentComponentsProvider.js";
const x = _ref => {
  let {
      value: r,
      tokens: o
    } = _ref,
    c = _objectWithoutProperties(_ref, _excluded);
  const n = s(p);
  if (!r) return null;
  if (typeof r == "string") return /* @__PURE__ */t(e.Fragment, {
    children: r
  });
  if (!Array.isArray(r)) return /* @__PURE__ */t(e.Fragment, {
    children: r.toString()
  });
  let i;
  return o && n && (i = {
    marks: {
      placeholder: _ref2 => {
        let {
          children: l
        } = _ref2;
        const m = n(o);
        return /* @__PURE__ */t(e.Fragment, {
          children: m(l)
        });
      }
    }
  }), /* @__PURE__ */t(d, _objectSpread(_objectSpread({}, c), {}, {
    value: r,
    components: i
  }));
};
export { x as UnstyledBlockContent };